import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    activeEventData:{},
    eventData:{},
    sponsorsList: [],
    totalTicketPrice:0,
    totalHeadCount:0
}

export const adminSlice = createSlice({
    name: "admin",
    initialState,
    reducers: {
        addActiveEventData: (state, action)=> {
            state.activeEventData = action.payload
        },
        addEventData: (state, action)=> {
            state.eventData = action.payload
        },
        setSponsorsList: (state, action) => {
            state.sponsorsList = action.payload
        },
        setTotalTicketPrice: (state, action) => {
            state.totalTicketPrice = action.payload
        },
        setTotalHeadCount: (state, action) => {
            state.totalHeadCount = action.payload
        }
    }
})

export const {addActiveEventData, addEventData, setSponsorsList, setTotalTicketPrice, setTotalHeadCount} = adminSlice.actions

export default adminSlice.reducer